import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserData } from "../../models/user";

const initialState: UserData = {
  is_login: false,
  status: "draft",
  is_verified: false,
  pendingKycRequest: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logged: (state, action: PayloadAction<UserData>) => {
      if (state) {
        state.type = action.payload.type;
        state.first_name = action.payload.first_name;
        state.dob = action.payload.dob;
        state.last_name = action.payload.last_name;
        state.phone = action.payload.phone;
        state.email = action.payload.email;
        state.profile_picture = action.payload.profile_picture;
        state.status = action.payload.status;
        state.aadhaar_number = action.payload.aadhaar_number;
        state.pan_number = action.payload.pan_number;
        state.gst = action.payload.gst;
        state.is_login = true;
        state.has_gst = action.payload.has_gst;
        state.organizer_id = action.payload.organizer_id;
        state.address = action.payload.address;
        state.workspace = action.payload.workspace;
        state.new_user = action.payload.new_user;
        state.currency = action.payload.currency || "";
        state.timezone = action.payload.timezone || "";
        state.legal_name = action.payload.legal_name || "";
        state.user_workspaces = action.payload.user_workspaces;
        state.organization = action.payload.organization;
        state.is_verified = action.payload.is_verified;
        state.pendingKycRequest = action.payload.pendingKycRequest;
        state.id = action.payload.id;
      }
    },
    setNewUser: (state, action: PayloadAction<boolean | undefined>) => {
      state.new_user = action.payload;
    },
    loggedOut: () => initialState,
  },
});

export const { logged, setNewUser, loggedOut } = userSlice.actions;
export default userSlice.reducer;
